



















































































































































































































































































































































































































import Vue from 'vue';
import axios from 'axios';

import SideTabs from '@/parts/mypage/SideTabs.vue';
import PageTabs from '@/parts/mypage/Tabs.vue';
import AddSkillModal from '@/parts/util/AddSkillModal.vue';
import MessageModal from "@/parts/util/MessageModal.vue";
import DeleteAccountConfirmModal from '@/parts/mypage/DeleteAccountConfirmModal.vue';
import CodeThemeRadioButton from '@/parts/mypage/CodeThemeRadioButton.vue';
import OfferMailRadioButton from '@/parts/mypage/OfferMailRadioButton.vue';
import ReturnTop from "@/parts/util/ReturnTop.vue";

import VariableInput, { VariableInputProps } from '@/components/util/VariableInput.vue'

import { updateUserProfile, getUserProfile, deletePaymentInformation, createAuthCode, updateTwoFactor } from '@/api/UserProfile';
import { UserSkill, IconUpdateFlag, GetUserProfileResponse } from '@/api/dto/UserProfile';
import { Language, Tool } from '@/api/dto/Skill';
import { defaultIconUrl } from '@/properties';

import { ErrorResponse } from '@/api/dto/Error';

/** 保存済みのプロフィールを保持しておくための型 */
type SavedProfile = Pick<GetUserProfileResponse, 
  'affiliation' |
  'affiliationUrl' |
  'githubUsername' |
  'iconUrl' |
  'mailAddress' |
  'phoneNumber' |
  'nickname' |
  'publishedMailAddress' |
  'selfIntroduction' |
  'skills' |
  'twitterUsername' |
  'websiteUrl'
>;

interface Data {
  tabs: { mode: 'profile' | 'account', text: string }[];
  defaultIconUrl: string;
  profileImage: File | null;
  profileUpdateFlag: IconUpdateFlag;
  /** 
   * 保存されたプロフィール情報
   * NOTE: API から取得したプロフィール情報
   */
  savedProfileData: SavedProfile;
  profileData: GetUserProfileResponse;
  basicInfo: Array<VariableInputProps & { key: string }>;
  detailedInfo: Array<VariableInputProps & { key: string }>;
  /** 離脱時の確認モーダル表示フラグ */
  leaveModal: boolean;
  langModal: boolean;
  toolModal: boolean;
  /** アカウント削除確認ダイアログ */
  deleteAccountConfirmModal: boolean;
  /** API処理中か */
  isApiProcessing: boolean;
  /** 次の遷移先パス */
  nextPath: string;
  /** 離脱可かどうか */
  allowLeave: boolean;
}

export default Vue.extend({
  name: 'Settings',
  components: {
    SideTabs,
    PageTabs,
    AddSkillModal,
    MessageModal,
    VariableInput,
    CodeThemeRadioButton,
    OfferMailRadioButton,
    DeleteAccountConfirmModal,
    ReturnTop,
  },
  props: {
    modeName: String,
  },
  watch: {
    'profileData.codeTheme': function(newVal, oldVal) {
      if (oldVal) {
        this.updateUserProfile();
      }
    },
    'profileData.nickname'(nickname: string) {
      this.basicInfo[0].error = nickname.length <= 15 ? '' : "表示名は15文字以内で入力してください";
    },
    'profileData.selfIntroduction'(selfIntroduction: string) {
      this.basicInfo[1].error = selfIntroduction.length <= 300 ? '' : "自己紹介は300文字以内で入力してください";
    },
    'profileData.twitterUsername'(twitterUsername: string) {
      this.detailedInfo[0].error = twitterUsername.length <= 30 ? '' : "Twitterユーザー名は30文字以内で入力してください";
    },
    'profileData.githubUsername'(githubUsername: string) {
      this.detailedInfo[1].error = githubUsername.length <= 30 ? '' : "GitHubユーザー名は30文字以内で入力してください";
    },
    'profileData.websiteUrl'(websiteUrl: string) {
      this.detailedInfo[2].error = websiteUrl.length <= 100 ? '' : "ウェブサイトは100文字以内で入力してください";
    },
    'profileData.publishedMailAddress'(publishedMailAddress: string) {
      this.detailedInfo[3].error = publishedMailAddress.length <= 100 ? '' : "掲載用メールは100文字以内で入力してください";
    },
    'profileData.affiliation'(affiliation: string) {
      this.detailedInfo[4].error = affiliation.length <= 100 ? '' : "所属先は100文字以内で入力してください";
    },
    'profileData.affiliationUrl'(affiliationUrl: string) {
      this.detailedInfo[5].error = affiliationUrl.length <= 100 ? '' : "所属先URLは100文字以内で入力してください";
    },
  },
  data(): Data {
    return {
      tabs: [
        { mode: 'profile', text: 'プロフィール設定' },
        { mode: 'account', text: 'アカウント設定' },
      ],
      defaultIconUrl,
      profileImage: null,
      profileUpdateFlag: "0",
      savedProfileData: {} as SavedProfile,
      profileData: {} as GetUserProfileResponse,
      basicInfo: [
        { key: 'nickname', name: '表示名', required: true, type: 'text', placeholder: '表示する名前を入力してください', error: '' },
        { key: 'selfIntroduction', name: '自己紹介', required: false, type: 'textarea', placeholder: '自己紹介を入力してください。職種や職歴、居住地など。', rows: 3, error: '' },
      ],
      detailedInfo: [
        { key: 'twitterUsername', name: 'Twitterユーザー名', type: 'text', placeholder: 'code123', error: '' },
        { key: 'githubUsername', name: 'GitHubユーザー名', type: 'text', placeholder: 'code123', error: '' },
        { key: 'websiteUrl', name: 'ウェブサイト', type: 'text', placeholder: 'URL', error: '' },
        { key: 'publishedMailAddress', name: '掲載用メール', type: 'text', placeholder: 'メールアドレス', error: '' },
        { key: 'affiliation', name: '所属先', type: 'text', placeholder: '所属先', error: '' },
        { key: 'affiliationUrl', name: '所属先URL', type: 'text', placeholder: 'URL', error: '' },
      ],
      // モーダル 関連
      leaveModal: false,
      langModal: false,
      toolModal: false,
      deleteAccountConfirmModal: false,
      isApiProcessing: false,
      // 画面離脱時に利用する情報
      nextPath: '',
      allowLeave: false,
    }
  },
  async beforeRouteEnter (to, from, next) {
    const res = await getUserProfile();
    next(vm => {
      (vm.$data as Data).profileData = {
        ...res,
        // 表示名が空の場合、ユーザーIDを表示する
        nickname: res.nickname ? res.nickname : this.$store.state.user.userId        
      };

      (vm.$data as Data).savedProfileData = {
        affiliation: res.affiliation,
        affiliationUrl: res.affiliationUrl,
        githubUsername: res.githubUsername,
        iconUrl: res.iconUrl,
        mailAddress: res.mailAddress,
        phoneNumber: res.phoneNumber,
        nickname: res.nickname,
        publishedMailAddress: res.publishedMailAddress,
        selfIntroduction: res.selfIntroduction,
        skills: res.skills,
        twitterUsername: res.twitterUsername,
        websiteUrl: res.websiteUrl,
      };
    });
  },
  async created() {
    this.$store.commit('setMode', { mode: this.modeName == 'account' ? 'account' : 'profile' });
  },
  /** ページ離脱時 */
  async beforeRouteLeave(to, from, next) {
    // プロフィールを編集したかどうか確認
    const edited = Object.entries(this.savedProfileData).some((
      [key, value]) => value !== this.profileData[key as keyof GetUserProfileResponse]);

    if(edited && !this.allowLeave){
      // プロフィール編集済みの場合は、離脱前確認モーダルを表示
      this.changeMode("profile");
      this.leaveModal = true;
      this.nextPath = to.path;
      next(false);
      return;
    }
    this.allowLeave = false;
    next();
  },
  computed: {
    mode() {
      return this.$store.state.mode;
    },
    userId(): string {
      return this.$store.state.user.userId;
    },
    skillLanguage(): UserSkill[] {
      try {
        return this.profileData.skills.filter(v => v.type === Language);
      } catch (e) { // undefindが返ってくる対策
        return [];
      }
    },
    skillTool(): UserSkill[] {
      try {
        return this.profileData.skills.filter(v => v.type === Tool);
      } catch (e) { // undefindが返ってくる対策
        return [];
      }
    },
    /**
     * どれかエラーがあればdisabled
     */
    submitDisabled(): boolean {
      return (this.basicInfo[0].error.length > 0 || this.basicInfo[1].error.length > 0
        || this.detailedInfo[0].error.length > 0 || this.detailedInfo[1].error.length > 0 || this.detailedInfo[2].error.length > 0
        || this.detailedInfo[3].error.length > 0 || this.detailedInfo[4].error.length > 0 || this.detailedInfo[5].error.length > 0)
    },
    getLastFourDigits(): string {
      return this.profileData.phoneNumber.substring(7, this.profileData.phoneNumber.length);
    },
    /** 設定中か未設定かの文字列を表示する */
    getTwoFactorInfo(): string {
      return this.profileData.isTwoFactor ? "設定中" : "未設定"
    },
  },
  methods: {
    changeMode(key: string) {
      this.$store.commit('setMode', { mode: key });
    },
    async getUserProfile() {
      try {
        const res = await getUserProfile();
        this.profileData = {
          ...res,
          // 表示名が空の場合、ユーザーIDを表示する
          nickname: res.nickname ? res.nickname : this.$store.state.user.userId
        };
        // ページ離脱時に編集有無を確認するために、現在のプロフィール情報を保持しておく
        this.setSavedProfile(res);
      } catch (e) {
        console.log(e);
      }
    },
    uploadFile(e: Event) {
      e.preventDefault();
      if (!(e?.target instanceof HTMLInputElement)) {
        return
      }
      const file = e.target.files?.[0];
      if (!file) {
        return;
      }
      this.profileImage = file;
      this.profileUpdateFlag = "1";
      this.profileData.iconUrl = URL.createObjectURL(file);
    },
    deleteFile() {
      this.profileImage = null;
      this.profileUpdateFlag = "2";
      this.profileData.iconUrl = "";
      (this.$refs.iconUploader as HTMLInputElement).value = '';
    },
    /** ページ離脱確認モーダル表示 */
    leaveModalOn() {
      this.leaveModal = true;
    },
    /** ページ離脱確認モーダル非表示 */
    leaveModalOff() {
      this.leaveModal = false;
    },
    langAddModalOn() {
      this.langModal = true;
    },
    langAddModalOff() {
      this.langModal = false;
    },
    setLangQueries(selected: string[]) {
      let setSkill = selected.map((v: string) => {
        return {
          type: Language,
          name: v,
          exp: this.skillLanguage.find(item => item.name == v)?.exp ?? 1 }
        }
      ) as UserSkill[];
      this.profileData.skills = [...setSkill, ...this.skillTool];
    },
    deleteSelectedLang(name: string) {
      this.profileData.skills = this.profileData.skills.filter(item => !(item.type == Language && item.name == name));
    },
    toolAddModalOn() {
      this.toolModal = true;
    },
    toolAddModalOff() {
      this.toolModal = false;
    },
    setToolQueries(selected: string[]) {
      let setSkill = selected.map((v: string) => {
        return {
          type: Tool,
          name: v,
          exp: this.skillTool.find(item => item.name == v)?.exp ?? 1 }
        }
      ) as UserSkill[];
      this.profileData.skills = [...this.skillLanguage, ...setSkill];
    },
    deleteSelectedTool(name: string) {
      this.profileData.skills = this.profileData.skills.filter(item => !(item.type == Tool && item.name == name));
    },
    async updateUserProfile() {
      if(this.mode === "profile" && !this.profileData.nickname){
        this.$emit("errorToast", "表示名は必須入力項目です");
        return;
      }

      try {
        const res = await updateUserProfile(this.profileImage, this.profileUpdateFlag, this.profileData);
        this.profileImage = null;
        this.profileUpdateFlag = "0";
        this.profileData.iconUrl = res.iconUrl;
        // アカウント設定タブの時は null になる
        if (this.$refs.iconUploader instanceof HTMLInputElement) {
          this.$refs.iconUploader.value = '';
        }
        this.$store.dispatch('userUpdate');
        this.$emit('toast', 'プロフィールを更新しました');
        this.setSavedProfile(this.profileData);
        this.destroy();
      } catch (e) {
        if (axios.isAxiosError(e)) {
          const res = (e.response?.data as ErrorResponse);
          if (res.code == '2004' || res.message == "禁止ワードが含まれているため送信に失敗しました") {
            this.$emit('errorToast', res.message);
            return;
          } 
        }
        this.$emit('errorToast', '更新に失敗しました。時間おいて再度お試しください');
      }
    },
    /**
     * アカウント削除モーダルを開く
     */
    openDeleteAccountModal() {
      this.deleteAccountConfirmModal = true;
    },
    /**
     * パスワード設定画面に遷移する
     */
    toSettingsPassword() {
      this.$router.push({ name: 'SettingsPassword' });
    },
    /**
     * メールアドレス設定画面に遷移する
     */
    toSettingsMailAddress() {
      this.$router.push({ name: 'SettingsMailAddress' });
    },
  /**
   * 電話番号設定画面に遷移する
   */
    toSettingsPhoneNumber() {
      this.$router.push({ name: 'SettingsPhoneNumber' });
    },
    /**
     * 決済情報設定画面に遷移する
     */
    toSettingsPayment() {
      this.$router.push({ name: 'SettingsPayment' });
    },
    /**
     * 番号認証画面に遷移する
     */
    toTwoFactor() {
      this.$router.push({ name: 'TwoFactor' });
    },
    /**
     * 決済情報削除APIを呼ぶ
     */
    async deletePaymentInformation() {
      try {
        this.isApiProcessing = true;
        await deletePaymentInformation();
        // ユーザー情報取得し更新
        this.$store.dispatch('userUpdate');
        await this.getUserProfile();
        this.$emit('toast', '決済情報を削除しました');
      } catch (e) {
        if (axios.isAxiosError(e)) {
          const res = (e.response?.data as ErrorResponse);
          if (res.code == '4026') {
            this.$emit('errorToast', res.message);
          } else {
            this.$emit('errorToast', '決済情報の削除に失敗しました');
          }
        }
      } finally {
        this.isApiProcessing = false;
      }
    },
    /** 
     * 保存済みの情報をセット
     * NOTE: ページ離脱時に編集有無を確認するための情報として利用
     */
    setSavedProfile(profileData: GetUserProfileResponse) {
      this.savedProfileData = {
        affiliation: profileData.affiliation,
        affiliationUrl: profileData.affiliationUrl,
        githubUsername: profileData.githubUsername,
        iconUrl: profileData.iconUrl,
        mailAddress: profileData.mailAddress,
        phoneNumber: profileData.phoneNumber,
        nickname: profileData.nickname,
        publishedMailAddress: profileData.publishedMailAddress,
        selfIntroduction: profileData.selfIntroduction,
        skills: profileData.skills,
        twitterUsername: profileData.twitterUsername,
        websiteUrl: profileData.websiteUrl,
      };
    },
    /** 破棄 */
    destroy() {
      this.leaveModalOff();
      this.allowLeave = true;
      if (this.nextPath) {
        this.$router.push(this.nextPath);
      }
    },
    /** 編集内容を保存 */
    saveLeave() {
      this.updateUserProfile();
    },
    /** 二要素認証のONとOFF */
   async setTwoFactor(){
      if (this.profileData.isTwoFactor) { //解除するボタンクリック
        // 二要素認証の設定を解除状態にする
        this.profileData.isTwoFactor = await updateTwoFactor(this.userId);
        this.$emit('toast', '二要素認証の設定を解除しました');
      } else { // 設定するボタンクリック
        // 認証コード発行
        await createAuthCode({
        userId: this.userId,
        phoneNumber: this.profileData.phoneNumber,
        purpose: "二要素認証設定",
      });
      this.$emit("toast", "認証コードを送信しました。");
      // 番号認証画面に遷移する
        this.toTwoFactor();
      }
    }
  }
})
